import {AfterViewInit, Component, effect, NgZone, ViewChild} from '@angular/core';
import {MdbButtonComponent} from '../../utils/mdb-button/mdb-button.component';
import {MdbCollapseModule} from 'mdb-angular-ui-kit/collapse';
import {MdbRippleModule} from 'mdb-angular-ui-kit/ripple';
import {MdbSidenavComponent, MdbSidenavModule} from 'mdb-angular-ui-kit/sidenav';
import {TranslateModule} from '@ngx-translate/core';
import {SidenavItemComponent} from './sidenav-item/sidenav-item.component';
import {finalize, fromEvent} from 'rxjs';

import {BreadcrumbsComponent} from '../../utils/breadcrumbs/breadcrumbs.component';
import {AuthService} from '../../../services/auth/auth.service';
import {HttpErrorsService} from '../../../services/utils/http-errors.service';
import {SidenavService} from '../../../services/utils/sidenav.service';

@Component({
  selector: 'app-sidenav',
  imports: [
    MdbButtonComponent,
    MdbCollapseModule,
    MdbRippleModule,
    MdbSidenavModule,
    TranslateModule,
    SidenavItemComponent,
    BreadcrumbsComponent,

  ],
  templateUrl: './sidenav.component.html',
  standalone: true,
  styleUrl: './sidenav.component.scss',
})
export class SidenavComponent implements AfterViewInit {
  @ViewChild('sidenav', {static: true}) sidenav!: MdbSidenavComponent;

  items = [
    {text: 'NAVIGATION.LOCATIONS', path: '/locations'},
    {text: 'NAVIGATION.MEETING_POINTS', path: '/meeting-points'},
    {text: 'NAVIGATION.VEHICLES', path: '/vehicles'},
    {text: 'NAVIGATION.EMPLOYEES', path: '/employees'},
    {text: 'NAVIGATION.ROUTES', path: '/routes'},
    {text: 'NAVIGATION.SETTINGS', path: '/settings'}
  ];
  activeItem = this.items[0];

  logoutLoading: boolean = false;

  constructor(
    public sidenavService: SidenavService,
    private ngZone: NgZone,
    private httpErrorService: HttpErrorsService,
    private authService: AuthService,
  ) {
    effect(() => {
      if (this.sidenavService.isHidden()) {
        setTimeout(() => {
          this.sidenav.hide();
        }, 0);
      } else {
        setTimeout(() => {
          this.sidenav.show();
        }, 0);
      }
    });
  }

  ngAfterViewInit() {
    this.ngZone.runOutsideAngular(() => {
      fromEvent(window, 'resize').subscribe(() => {
        if (
          window.innerWidth < this.sidenavService.breakWidth &&
          !this.sidenavService.isOverMode()
        ) {
          this.ngZone.run(() => {
            this.sidenavService.isOverMode.set(true);
            this.sidenavService.hide();
          });
        } else if (
          window.innerWidth >= this.sidenavService.breakWidth &&
          this.sidenavService.isOverMode()
        ) {
          this.ngZone.run(() => {
            this.sidenavService.isOverMode.set(false);
            this.sidenavService.show();
          });
        }
      });
    });
  }

  itemClick(item: any) {
    this.activeItem = item;
    // this.breadcrumbService.clearBreadcrumbs(item)
    if (this.sidenavService.isOverMode()) this.sidenavService.hide();
  }

  logout() {
    this.logoutLoading = true;
    this.authService
      .logout()
      .pipe(finalize(() => (this.logoutLoading = false)))
      .subscribe({
        next: () => {
          this.authService.user.set(null);
          // this.router.navigate(['/auth/login'])
          window.location.href = '';
        },
        error: (err) => {
          this.httpErrorService.handleError(err);
        },
      });
  }
}
